import React, { createContext, useContext } from 'react';
const Context = /*#__PURE__*/createContext(null);
export const OverrideAbTest = ({
  children,
  abTest
}) => {
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: abTest
  }, children);
};
export const useOverrideAbTest = () => {
  return useContext(Context);
};